import type { Status, RecordEntity } from './../records';

export interface Role extends RecordEntity {
  id: string;
  name: string;
  description: string;
  status: Status;
  userCount: number;
  createdAt: string | number | Date;
  updatedAt: string | number | Date;
}

export interface User extends RecordEntity {
  company?: string;
  department?: string;
  email?: string;
  fullName?: string;
  firstName?: string;
  lastLoggedInAt?: string | number | Date;
  lastName?: string;
  locale?: string;
  meta?: JSON;
  oAuthId?: string;
  sAMAccountName?: string;
  telephone?: string;
  title?: string;
  username?: string;
  roles?: Role[];
}

export interface UserListEntry {
  name: string;
  firstName?: string;
  lastName?: string;
  initials: string;
  role: string;
  menuRole: string;
  badgeColour: string;
  info: { email: string; phone: string };
  id: string;
  is: {
    disabled?: boolean;
    locked_out?: boolean;
    verified?: boolean;
    phone_verified?: boolean;
    deleted?: boolean;
    placeholder?: boolean;
  };
  status: boolean;
  // only legacy users have this
  srcText?: string;
  sortText?: string;
  dateCreated?: string;
  dateModified: string;
  lastAccessed: string;
  hasMenuAccess: boolean;
  hasManageUserAccess: boolean;
  temporaryAdminAccessExpiry?: string;
}

export enum UserExportStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum P2Role {
  SYS_ADMIN = 'sys_admin',
  ADMIN = 'admin',
  SITE_OPERATOR = 'site_operator',
  IM_USER = 'im_user',
  MENU_USER = 'menu_user',
  DC_TEAM = 'dc_team',
  RUNNER = 'runner',
  SUPER_ADMIN = 'super_admin',
}

export enum MenuRoles {
  GLOBAL_MENU_GROUP_ADMIN = 'global_menu_group_admin',
  LOCAL_MENU_GROUP_ADMIN = 'local_menu_group_admin',
  GLOBAL_MENU_GROUP_MANAGER = 'global_menu_group_manager',
  LOCAL_MENU_GROUP_MANAGER = 'local_menu_group_manager',
  LOCAL_MENU_GROUP_LIMITED_EDITS = 'local_menu_group_limited_edits',
}

export const PermissionScope = {
  refundOrder: 'write:order:*',
  reports: 'read:centricReports:*',
  legacyReportsPermission: 'report:c360:*',
  canManageDropoffLocations: 'write:deliverydestination:*',
  announcement: 'write:centric_announcement:*',
};

export const AdminPanelPermissionScope = {
  users: '*:users',
};

export enum MenuScopeActions {
  READ = 'read',
  WRITE = 'write',
  WRITE_NESTED = 'write_nested',
  WRITE_NESTED_PUBLISH = 'write_nested_publish',
  WRITE_NESTED_IS_ACTIVE = 'write_nested_is_active',
  SITE_ENABLED_WRITE_NESTED = 'site_enabled_write_nested',
  SITE_ENABLED_WRITE_NESTED_IS_ACTIVE = 'site_enabled_write_nested_is_active',
  SITE_ENABLED_WRITE_NESTED_PUBLISH = 'site_enabled_write_nested_publish',
}
export enum MenuScopeServices {
  LOCAL_MENU_GROUP = 'local_menu_group',
  GLOBAL_MENU_GROUP = 'global_menu_group',
}
